<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="totaleBilance > 0"
      item-key="codice"
      :headers="headers"
      :items="bilanceSorted"
      :options.sync="options"
      :server-items-length="totaleBilance"
      :loading="loading"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      show-expand
      dense
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Bilance</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class="mb-2" @click="onNuovoBilancia">Nuova Bilancia</v-btn>
        <dialog-errore :show="dialogErrore" title="" />
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Confermi cancellazione bilancia?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm" block>SI</v-btn>
              <v-btn color="blue darken-1" text @click="closeDelete">NO</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.attiva`]="{ item }">
      {{ item.attiva ? 'SI' : 'NO' }}
    </template>
<!--     <template v-slot:[`item.dataDa`]="{ item }">
      {{ item.dataDa | dateNull }}
    </template>
    <template v-slot:[`item.dataA`]="{ item }">
      {{ item.dataA | dateNull }}
    </template>
    <template v-slot:[`item.quantitaMinima`]="{ item }">
      {{ item.quantitaMinima | dueDecimali }}
    </template> -->
    <template v-slot:[`item.actions`]="{ item }">
    <!-- <v-icon small class="mr-2" @click="duplicateItem(item)" title="Duplica il prodotto">mdi-content-duplicate</v-icon> -->
      <v-icon small class="mr-2" @click="deleteItemWithPassword(item)" title="Cancella l'bilancia">mdi-delete</v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="getDataFromApi">Ricarica</v-btn>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="bilanceSelected">
        <v-tabs dense v-model="tab[item.codice]">
          <v-tab key="mappaturaPlu" class="bilanceSelected">Mappatura PLU</v-tab>
<!--           <v-tab key="periodi" class="bilanceSelected">Periodi</v-tab>
          <v-tab key="categorie" v-if="item.tipoBilancia === 'categoria'" class="bilanceSelected">Categoria</v-tab>
          <v-tab key="prodotti" v-if="item.tipoBilancia === 'prodotto'" class="bilanceSelected">Prodotti</v-tab> -->
        </v-tabs>
        <v-tabs-items v-model="tab[item.codice]">
          <v-tab-item key="mappaturaPlu">
            <mappatura-plu :bilancia="item" :refresh="trigRefresh" @salva="salvaBilancia"/>
          </v-tab-item>
<!--           <v-tab-item key="periodi">
            <periodi :dati="item" :refresh="trigRefresh" @salva="salvaBilance"/>
          </v-tab-item>
          <v-tab-item key="categorie" v-if="item.tipoBilancia === 'categoria'">
            <categorie :dati="item" :refresh="trigRefresh" @salva="salvaBilance"/>
          </v-tab-item>
          <v-tab-item key="prodotti" v-if="item.tipoBilancia === 'prodotto'">
            <prodotti :dati="item" :refresh="trigRefresh" @salva="salvaBilance"/>
          </v-tab-item>  --> 
        </v-tabs-items>
      </td>
    </template>
    </v-data-table>
  </div>
</template>

<script>
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import DialogErrore from '@/components/dialogErrore'
  import MappaturaPlu from './elementi/mappaturaPlu'
  import configurazioni from '@/services/configurazioniService.js'

  export default {
    components: {
      DialogErrore,
      MappaturaPlu
    },
    mixins: [verificaLicenza],
    data () {
      return {
        totaleBilance: 0,
        bilance: [],
        selected: [],
        loading: true,
        options: { itemsPerPage: 50 },
        headersDefault: [ // Caricato se non ci sono impostazioni diverse nel DB
          { text: 'Codice bilancia', value: 'codiceBilancia', align: 'start' },
          { text: 'Raggruppa', value: 'gruppoBilance' },
          { text: 'Descrizione', value: 'descrizione' },
          { text: 'Attiva', value: 'attiva' },
          { text: 'Protocollo', value: 'protocollo' },
          { text: 'Marca', value: 'marca' },
          { text: 'Modello', value: 'modello' },
          { text: 'Actions', value: 'actions', sortable: false },
          { text: '', value: 'data-table-expand' }
        ],
        headersBase: [
          { text: 'Actions', value: 'actions', sortable: false },
          { text: '', value: 'data-table-expand' }
        ],
        headersSpeciali: [
          { text: '', value: 'speciali', width: 80 }
        ],        
        headersBO: [],
        dialogErrore: false,
        dialogDelete: false,
        dialogECommerce: false,
        editedIndex: -1,
        editedItem: null,
        defaultItem: null,
        defaultItemPlu: null,
        filtri: {
          tipoItem: 'PRODOTTO',
          testo: '',
          marchio: [],
          variante1: [],
          variante2: [],
          stagione: [],
          categoria1: [],
          categoria2: []   
        },
        expanded: [],
        singleExpand: false,
        tab: {},
        trigRefresh: 0,
        usaTagliaColore: false,
        usaLotti: false,
        usaDistintaBase: false,
        usaVariazioni: false,
        codiceCancellazione: '0000',
        moduloECommerce: false,
        moduloLotti: false
      }
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuovo Bilancia' : 'Modifica Bilancia'
      },
      bilanceSorted() {
        const els = this.bilance
        if (this.options.sortBy && this.options.sortBy.length > 0) {
          return els
        } else {
          const elSorted = els
          return elSorted
        }
      },
      headers() {
        return this.headersDefault
      }
    },
    watch: {
      options: {
        async handler () {
          await this.getDataFromApi()
        },
        deep: true
      },
      dialogDelete (val) {
        val || this.closeDelete()
      }
    },
    async created() {
      this.defaultItem = {
        codiceBilancia: '',
        descrizione: '',
        attiva: false,
        protocollo: '',
        marca: '',
        modello: '',
        qrCode: null,
        file: null,
        plu: []
      }
      this.defaultItemPlu = {
        codicePlu: '',
        codiceProdotto: '',
        descrizionePlu: '',
        tipo: 'peso',
        isReparto: false
      }
      /* 
        const backoffice = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
        this.usaTagliaColore = backoffice.usaTagliaColore || false
        this.codiceCancellazione = backoffice.codiceCancellazione || '0000'
      */
    },
    async mounted () {
      await this.gestioneToken()
    },
    methods: {      
      async getDataFromApi() {
        try {
          this.loading = true
          this.bilance = await configurazioni.getConfigurazione('bilance', 'elenco')

          this.totaleBilance = this.bilance.length
        } catch(err) {
          this.bilance = []
          this.totaleBilance = 0
        } finally {
          this.loading = false
        }
      },
      async onNuovoBilancia() {
        this.editedIndex = -1
        this.editedItem = Object.assign({}, JSON.parse(JSON.stringify(this.defaultItem)))
        let na = _.cloneDeep(this.defaultItem)
        na.codice = await configurazioni.getNumeratore('bilancia', true)
        this.bilance.push(na)
      },
      editItem(item) {
        this.editedIndex = this.bilance.indexOf(item)
        this.editedItem = Object.assign({}, item)
      },
      duplicateItem(item) {
        this.editedIndex = -1
        this.editedItem = Object.assign({}, item)
        this.editedItem._id = ''
        this.editedItem.barcode = []
        this.editedItem.ricercaBarcode = ''
        delete this.editedItem._rev
      },
      deleteItemWithPassword(item) {
        if (prompt('inserire codice per cancellazione') === this.codiceCancellazione) {
          this.deleteItem(item)
        }
      },
      deleteItem (item) {
        this.editedIndex = this.bilance.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      async deleteItemConfirm () {
        this.bilance.splice(this.editedIndex, 1)
        await this.salvaBilance()
        this.closeDelete()
      },

      close() {
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete() {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      async salvaBilancia(codiceBilancia, elencoPlu) {
        this.loading = true
        let bilance = await configurazioni.getConfigurazione('bilance')
        let bilancia = bilance.elenco.find(x => x.codiceBilancia === codiceBilancia)
        bilancia.plu = elencoPlu
        await configurazioni.modificaConfigurazione(bilance)
        this.loading = false          
      },
      erroreConfirm() {
        this.dialogErrore = false
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  {
    box-shadow: none !important;
  }
    td.bilanceSelected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }
</style>
